import { FC, useEffect } from 'react';

import { Settings } from 'utils/constants/dynamicSettings';

import { VSpacing } from '@hh.ru/magritte-ui';

import useSettings from 'hooks/useSettings';

import { BannerVideoTitle } from 'components/common/BannerVideo/BannerVideoTitle/BannerVIdeoTitle';
import { UploadedVideo } from 'components/common/BannerVideo/UploadedVideo/UploadedVideo';
import { UploadField } from 'components/common/BannerVideo/UploadField/UploadField';
import { fetchLoadVideoGallery } from 'components/common/BannerVideo/VideoGallery/fetchLoadVideoGallery';
import { VideoGallery } from 'components/common/BannerVideo/VideoGallery/VideoGallery';
import withErrorBoundary from 'components/common/ErrorBoundary/withErrorBoundary';

import { selectVideoGalleryItems } from 'store/models/videoGallery';
import { useDispatch, useSelector } from 'store/utils';

const BannerVideoComponent: FC = () => {
    const bannerVideo = useSelector((state) => state.createBanner.bannerVideo);
    const videos = useSelector(selectVideoGalleryItems);
    const isVideoUploaded = !!bannerVideo?.videoUploadId;

    const settings = useSettings();
    const dispatch = useDispatch();

    const isAllowedToUploadVideo = settings(Settings.EnableUploadVideoForYandex) as boolean;

    useEffect(() => {
        dispatch(fetchLoadVideoGallery());
    }, [dispatch]);

    return (
        <>
            {isAllowedToUploadVideo && (
                <div>
                    <VSpacing default={32} />
                    <BannerVideoTitle />
                    <VSpacing default={12} />
                    <UploadField />
                    {videos.length > 0 && (
                        <>
                            <VSpacing default={24} />
                            <VideoGallery />
                        </>
                    )}
                    {isVideoUploaded && (
                        <>
                            <VSpacing default={24} />
                            <UploadedVideo />
                        </>
                    )}
                </div>
            )}
        </>
    );
};

const BannerVideo = withErrorBoundary(BannerVideoComponent);
export { BannerVideo };
